import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthUser } from "../../contexts/AuthUserContext";
import { useLocalization } from "../../contexts/LocalizationContext";

const PENDING_WELCOME_INTENT_KEY = "zeqi:pendingWelcomeIntent";
const ACTIVE_CHANNEL_STORAGE_KEY = "zeqi:activeChannelId";
const ACTIVE_SUBCHANNEL_STORAGE_KEY = "zeqi:activeSubchannelId";

const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { signIn, refreshUser } = useAuthUser();
  const { t } = useLocalization();

  useEffect(() => {
    let cancelled = false;

    const completeAuth = async () => {
    const userId = searchParams.get("userId");
    const token = searchParams.get("token");
    const shop = searchParams.get("shop");
    const success = searchParams.get("success");
    const nextRoute = searchParams.get("nextRoute") || "/";
    const welcomeIntent = searchParams.get("welcomeIntent");

    if (!userId || !token) {
      console.error("Missing authentication data in callback");
      navigate("/login", { replace: true });
      return;
    }

    try {
      window.sessionStorage.setItem(ACTIVE_CHANNEL_STORAGE_KEY, "main");
      window.sessionStorage.removeItem(ACTIVE_SUBCHANNEL_STORAGE_KEY);
      if (welcomeIntent) {
        window.sessionStorage.setItem(PENDING_WELCOME_INTENT_KEY, welcomeIntent);
      }
    } catch {
      // ignore sessionStorage issues
    }

    signIn({
      userId,
      token,
      shop: shop || null,
      success: success === "true",
    });

    try {
      await refreshUser(token);
    } catch {
      // non-fatal; optimistic sign-in is already set
    }

    if (!cancelled) {
      navigate(nextRoute, { replace: true });
    }
    };

    completeAuth();
    return () => {
      cancelled = true;
    };
  }, [searchParams, signIn, refreshUser, navigate]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <p>
        {t("AuthCallbackPage.authenticating", {
          defaultValue: "Authenticating...",
        })}
      </p>
    </div>
  );
};

export default AuthCallbackPage;
